module.exports = __webpack_public_path__ + "static/media/what_i_do.b4160568.svg";